export const getErrorMessage = ({err, title = 'Ocurrió un error'}: {err:any, title?: string}) => {
  let subtitle = ''
  if(!err?.response?.data?.error?.includes('TypeORMError') && err?.response?.data?.message){
    subtitle = err?.response?.data?.message
  }
  return { title, subtitle }
}